import axios from 'axios'

const client = axios.create({
  withCredentials: true,
})

client.defaults.baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001/'
    : process.env.REACT_APP_ENV === 'qa'
    ? 'https://apiqa.motiners.com/'
    : 'https://api.motiners.com/'

export default client
